// extracted by mini-css-extract-plugin
export default {"root":"ConsoleLayout_root__43CBj","juan":"ConsoleLayout_juan__aQfBc","expand":"ConsoleLayout_expand__UVcsg"};